define(function(require) {
  const ViewManager = require('civicsUtils/view_manager');
  const SyncModel = require('civicsModels/sync_model');

  return {
    hasSavedSyncMapping: function(features) {
      var savedSyncData = App.sessionStorage.get('CIVICS', 'SYNC_DATA') ? App.sessionStorage.get('CIVICS',
        'SYNC_DATA') : [];

      for (var i = 0; i < savedSyncData.length; i++) {
        var elt = savedSyncData[i];
        if (features['syncMapping'] != null && features['syncMapping'] == elt['syncMapping']) {
          return true;
        } else if (features['syncMoniker'] != null && features['syncMoniker'] == elt['syncMoniker']) {
          return true;
        }
      }


      return false;
    },
    saveSyncDataToSessionStorage: function(models) {
      var savedSyncData = App.sessionStorage.get('CIVICS', 'SYNC_DATA') ? App.sessionStorage.get('CIVICS',
        'SYNC_DATA') : [];

      models.forEach(model => {

        if (model.syncType == 'syncMapping') {
          savedSyncData.push({
            'syncMappingId': model.get('syncMapping'),
            'name': model.get('name'),
            'syncMapping': model.syncValue
          });
        } else if (model.syncType == 'syncMoniker') {
          savedSyncData.push({
            'syncMappingId': model.get('syncMapping'),
            'name': model.get('name'),
            'syncMoniker': model.syncValue
          });
        }
      });

      App.sessionStorage.set('CIVICS', 'SYNC_DATA', savedSyncData);
    },
    createSyncModel: function(features) {
      // no need to look it up if we already have the sync key field
      if (features['syncKeyField']!=null && features['syncKeyField'].trim()!='') {
        return null;
      }

      // if we are only given the syncKeyField with no moniker or syncMapping,
      // just assume the syncKeyField is unique across all layers
      if (features['syncKeyField'] != '' && features['syncMoniker'] == null && features['syncMapping'] == null) {
        return null; 
      }

      if (!this.hasSavedSyncMapping(features)) {
        var syncModel = new SyncModel();
        if (features['syncMapping']) {
          syncModel.syncType = 'syncMapping';
          syncModel.syncValue = features['syncMapping'];
        } else if (features['syncMoniker']) {
          syncModel.syncType = 'syncMoniker';
          syncModel.syncValue = features['syncMoniker'];
        } else {
          return null;
        }
        return syncModel;
      }
      return null;
    },
    mapSyncKeys: function(model) {
      var gisToIpsMapping = {};

      var keyList = model.toJSON();

      keyList.forEach(item => {
        gisToIpsMapping[item.gisKey + "-" + item.syncMapping] = item.ipsKey;
        gisToIpsMapping[item.gisKey] = item.ipsKey;
      });

      return gisToIpsMapping;
    },
    getGisKeyFromMapping: function(attributes) {
      var mapping = {};

      if (attributes['syncKeyField']) {
        mapping.gisKey = attributes[attributes['syncKeyField']];
      }

      var savedSyncData = App.sessionStorage.get('CIVICS', 'SYNC_DATA') ? App.sessionStorage.get('CIVICS',
        'SYNC_DATA') : [];

      if (attributes['syncMoniker']) {
        mapping.ipsMoniker = attributes['syncMoniker'];

        for (var i = 0; i < savedSyncData.length; i++) {
          var element = savedSyncData[i];

          if (element['syncMoniker'] == attributes['syncMoniker']) {
            mapping.gisKey = attributes[element['name']];
          }
        }
      } else if (attributes['syncMapping'] != null) {
        for (var i = 0; i < savedSyncData.length; i++) {
          var element = savedSyncData[i];

          if (element['syncMapping'] == attributes['syncMapping']) {
            mapping.syncMapping = element['syncMappingId'];
            mapping.gisKey = attributes[element['name']];
          }
        }
      }

      return mapping;
    }
  }
});
